<template>
  <!-- <coming-soon /> -->
  <b-card no-body class="p-2 card-create">
    <b-row>
      <b-col cols="12" md="6">
        <b-row>
          <b-col cols="12">
            <toggle
              :fieldProperties="statusProperty"
              ref="statusToggle"
              @change.native="onToggleStatus"
            />
          </b-col>
          <b-col cols="12" class="mt-1">
            <label for="set-name" class="required">
              Set Name
            </label>
            <b-form-input
              id="set-name"
              placeholder="Set Name"
              required
              class="textbox-input"
              v-model="form.name"
            />
          </b-col>
          <b-col cols="12" class="mt-1">
            <label for="set-description" class="required">
              Description
            </label>
            <b-form-textarea
              id="set-description"
              placeholder="Description..."
              required
              class="textbox-input"
              :max-rows="4"
              :rows="4"
              v-model="form.description"
            />
          </b-col>
          <b-col cols="12" class="mt-1">
            <label for="valid-from-date" class="required">
              Valid From
            </label>
            <div class="d-flex">
              <div class="p-relative mr-1">
                <calendar-picker-icon
                  class="icon-calendar bypass"
                  :class="form.validFrom.date ? 'date-selected-icon' : null"
                />
                <flat-pickr
                  :id="'valid-from-date'"
                  class="form-control  bg-date"
                  :class="form.validFrom.date ? 'date-selected' : null"
                  :config="flatpickrDateConfig"
                  placeholder="Start Date"
                  required
                  autocomplete="off"
                  v-model="form.validFrom.date"
                  @on-open="onOpenValidFromDatePicker"
                  @on-change="onSelectValidFromDate"
                />
              </div>
              <div class="p-relative w-25">
                <clock-picker-icon
                  class="icon-calendar date-picker-icon bypass"
                  :class="form.validFrom.time ? 'date-selected-icon' : null"
                />
                <flat-pickr
                  id="valid-from-time"
                  class="form-control  bg-date"
                  :class="form.validFrom.time ? 'date-selected' : null"
                  :config="flatpickrTimeConfig"
                  :placeholder="'HH : mm'"
                  required
                  autocomplete="off"
                  v-model="form.validFrom.time"
                  @on-open="onOpenValidFromTimePicker"
                  @on-change="onSelectValidFromTimePicker"
                />
              </div>
            </div>
          </b-col>
          <b-col cols="12" class="mt-1">
            <label for="valid-from-to" class="required">
              Valid Through
            </label>
            <div class="d-flex">
              <div class="p-relative mr-1">
                <calendar-picker-icon
                  class="icon-calendar bypass"
                  :class="form.validThrough.date ? 'date-selected-icon' : null"
                />
                <flat-pickr
                  :id="'valid-to-date'"
                  class="form-control  bg-date"
                  :class="form.validThrough.date ? 'date-selected' : null"
                  :config="flatpickrDateConfig"
                  placeholder="End Date"
                  required
                  autocomplete="off"
                  v-model="form.validThrough.date"
                />
              </div>
              <div class="p-relative w-25">
                <clock-picker-icon
                  class="icon-calendar date-picker-icon bypass"
                  :class="form.validThrough.time ? 'date-selected-icon' : null"
                />
                <flat-pickr
                  id="valid-from-time"
                  class="form-control  bg-date"
                  :class="form.validThrough.time ? 'date-selected' : null"
                  :config="flatpickrTimeConfig"
                  :placeholder="'HH : mm'"
                  required
                  autocomplete="off"
                  v-model="form.validThrough.time"
                  @on-open="onOpenValidThroughTimePicker"
                />
              </div>
            </div>
          </b-col>
          <b-col cols="12" class="mt-1">
            <b-form-group label="Layout Section" label-for="layout-section">
              <b-form-input id="layout-section" v-model="form.layoutSection" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="6" class="right-side-information  mt-1 mt-md-0">
        <b-col cols="12">
          <toggle
            :fieldProperties="carouselProperty"
            ref="carouselToggle"
            @change.native="onToggleCarousel"
          />
        </b-col>
        <b-col cols="12" class="mt-1">
          <b-form-group label="Layout" class="layout-label required">
            <b-form-radio-group
              name="radio-sub-component"
              required
              v-model="form.carouselLayout"
            >
              <b-form-radio
                class="layout-radio custom-checkbox-circle mb-1"
                :value="1"
              >
                <b-card no-body class="layout-card px-1" :class="form.carouselLayout == 1 ? '':'not-shadow'">
                  <div class="d-flex flex-column h-100 justify-content-center">
                    <carousel-1 class="carousel-image" />
                    <div class="text-center mt-1">1</div>
                  </div>
                </b-card>
              </b-form-radio>
              <b-form-radio
                class="layout-radio custom-checkbox-circle mb-1"
                :value="2"
              >
                <b-card no-body class="layout-card px-1" :class="form.carouselLayout == 2 ? '':'not-shadow'">
                  <div class="d-flex flex-column h-100 justify-content-center">
                    <carousel-2 class="carousel-image" />
                    <div class="text-center mt-1">2</div>
                  </div>
                </b-card>
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
  import {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BButton,
  } from 'bootstrap-vue';
  import ComingSoon from '@/views/components/coming-soon/ComingSoon.vue';
  import Toggle from '@/views/components/dynamic-fields/components/ToggleFields.vue';
  import flatPickr from 'vue-flatpickr-component';
  import ClockPickerIcon from '@/@core/components/svg/common/ClockPicker.vue';
  import CalendarPickerIcon from '@/@core/components/svg/common/CalendarPicker.vue';
  import Carousel1 from '@/@core/components/svg/create-info/Carousel1.vue';
  import Carousel2 from '@/@core/components/svg/create-info/Carousel2.vue';
  import Carousel3 from '@/@core/components/svg/create-info/Carousel3.vue';
  import Carousel4 from '@/@core/components/svg/create-info/Carousel4.vue';

  import useCreateSetBannerInformation from '../hooks/useCreateSetBannerInformation';

  export default {
    components: {
      BRow,
      BCol,
      BCard,
      BCardHeader,
      ComingSoon,
      BForm,
      Toggle,
      BFormInput,
      BFormTextarea,
      ClockPickerIcon,
      CalendarPickerIcon,
      BFormGroup,
      BFormCheckboxGroup,
      BFormCheckbox,
      BFormRadioGroup,
      BFormRadio,
      Carousel1,
      Carousel2,
      Carousel3,
      Carousel4,
      BButton,
      flatPickr,
    },

    props: {
      setBanner: Object,
    },

    setup(props) {
      const {
        statusProperty,
        flatpickrDateConfig,
        flatpickrTimeConfig,
        form,
        carouselProperty,
        onToggleCarousel,
        onToggleStatus,
        onOpenValidFromDatePicker,
        onSelectValidFromDate,
        onOpenValidFromTimePicker,
        onOpenValidThroughTimePicker,
        onSelectValidFromTimePicker,
      } = useCreateSetBannerInformation(props);

      return {
        statusProperty,
        flatpickrDateConfig,
        flatpickrTimeConfig,
        form,
        carouselProperty,
        onToggleCarousel,
        onToggleStatus,
        onOpenValidFromDatePicker,
        onSelectValidFromDate,
        onOpenValidFromTimePicker,
        onOpenValidThroughTimePicker,
        onSelectValidFromTimePicker,
      };
    },
  };
</script>

<style></style>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style scoped>
  @import '~@/assets/css/pages/banner/banner-table.css';
  @import '~@/assets/css/pages/banner/create-banner.css';
  @import '~@/assets/css/pages/banner/create-set-banner.css';
  @import '~@/assets/css/pages/data-management.css';
  @import '~@/assets/css/override-styles/dynamic-fields.css';
</style>
